import { createFileRoute } from '@tanstack/react-router'
import { LibraDashboardPage } from 'pages/libraDashboard/LibraDashboardPage'
import z from 'zod'

import { SEARCH_PARAM_ORG_ID } from './(global_search_params)/-searchParams'

const searchParams = z.object({
  // makes org-id a required param
  [SEARCH_PARAM_ORG_ID]: z.string(),
})

export const Route = createFileRoute('/nii-dashboard/')({
  component: RouteComponent,
  validateSearch: searchParams,
  staticData: {
    title: 'NII Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  const { orgId } = Route.useSearch()

  return <LibraDashboardPage orgId={orgId} />
}
